import { Injectable } from '@angular/core'

import { BehaviorSubject } from 'rxjs'

import type { FilterDialogConfig } from '../types/types'

@Injectable({
  providedIn: 'root',
})
export class FilterDialogService {
  private readonly dialogConfigSubject =
    new BehaviorSubject<FilterDialogConfig>({
      showMagazineDialog: false,
      showAuthorDialog: false,
      showTypeDialog: false,
    })

  readonly dialogConfig$ = this.dialogConfigSubject.asObservable()

  toggleDialog(type: keyof FilterDialogConfig): void {
    const currentConfig = this.dialogConfigSubject.value
    const newConfig = { ...currentConfig }

    // Close all other dialogs
    Object.keys(newConfig).forEach(key => {
      newConfig[key as keyof FilterDialogConfig] =
        key === type ? !currentConfig[type] : false
    })

    this.dialogConfigSubject.next(newConfig)
  }

  getDialogState(type: keyof FilterDialogConfig): boolean {
    return this.dialogConfigSubject.value[type]
  }

  getCurrentConfig(): FilterDialogConfig {
    return this.dialogConfigSubject.value
  }

  closeAllDialogs(): void {
    this.dialogConfigSubject.next({
      showMagazineDialog: false,
      showAuthorDialog: false,
      showTypeDialog: false,
    })
  }

  isAnyDialogOpen(): boolean {
    return Object.values(this.dialogConfigSubject.value).some(isOpen => isOpen)
  }

  setDialogState(type: keyof FilterDialogConfig, isOpen: boolean): void {
    const currentConfig = this.dialogConfigSubject.value
    this.dialogConfigSubject.next({
      ...currentConfig,
      [type]: isOpen,
    })
  }
}
